exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TeamSchedule__header--2MBKc {\n  font-weight: 400;\n  margin-top: 20px;\n}\n\n.TeamSchedule__recentEvent--41cQp.TeamSchedule__scheduleRow--3SnOf {\n  color: #0078fd;\n}\n\n.TeamSchedule__scheduleRow--3SnOf > div:nth-child(2) {\n  text-align: center;\n}\n\n.TeamSchedule__scheduleRow--3SnOf > div:nth-child(3) {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.TeamSchedule__events--3knNS > div {\n  border-top: solid 1px #1e1f21;\n}\n\n.TeamSchedule__teamSchedule--1l26D {\n  margin-bottom: 40px;\n}\n.TeamSchedule__teamSchedule--1l26D h3 {\n  margin-left: 10px;\n}", ""]);

// exports
exports.locals = {
	"header": "TeamSchedule__header--2MBKc",
	"recentEvent": "TeamSchedule__recentEvent--41cQp",
	"scheduleRow": "TeamSchedule__scheduleRow--3SnOf",
	"events": "TeamSchedule__events--3knNS",
	"teamSchedule": "TeamSchedule__teamSchedule--1l26D"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };